import React, { useMemo, useState } from 'react'
import Table from 'antd/lib/table'

import useQuery from 'hooks/useQuery'
import apiManager from 'helpers/apiManager'
import { dateFormatter } from 'helpers'

import { CloseIcon } from 'components'
import Modal from 'components/AuthModal/components/Modal'
import Overlay from 'components/AuthModal/components/Overlay'
import DarkPrimaryButton from 'components/DarkPrimaryButton'
import NewFeedbackModal from 'pages/admin/AdminUser/NewFeedbackModal'

import { OVERLAY } from 'components/AuthModal/styles'

const getSorter =
  ({ key, formatter = data => data }) =>
  (a, b) =>
    formatter(a[key]) - formatter(b[key])

const columns = [
  {
    title: 'ID',
    dataIndex: 'id',
    key: 'id',
    sorter: getSorter({ key: 'id' }),
  },
  {
    title: 'text',
    dataIndex: 'text',
    key: 'purpose',
  },
  {
    title: 'Created',
    dataIndex: 'createdAt',
    key: 'createdAt',
    render: dateFormatter.returnYYYYMMDD,
    sorter: getSorter({ key: 'createdAt', formatter: data => new Date(data) }),
  },
]

const FeedbackModal = ({ user, show, onClose }) => {
  const [showNewFeedbackModal, setShowNewFeedbackModal] = useState(false)

  const { data, refetch } = useQuery('admin/match-feedback', () =>
    apiManager.adminGetMatchFeedback(
      {
        userId: user.id,
      },
      {
        enabled: show,
      }
    )
  )

  const feedback = useMemo(
    () =>
      data?.map(match => ({
        ...match,
        key: match.id,
      })) || [],
    [data]
  )

  return (
    <Overlay show={show} className={OVERLAY} preventEscBackdropClose={true} onClose={onClose}>
      <Modal innerClassName="w-screen max-w-auto px-10 rounded-t-3xl max-w-auto overflow-y-scroll">
        <div className="relative w-full p-5 max-w-full md:p-7 md:py-5 bg-white">
          <button className="bg-transparent text-black absolute top-3 right-4" onClick={onClose}>
            <CloseIcon className="w-4 h-4" />
          </button>
          <div className="text-black text-center text-5xl font-bold font-ownersWide mb-10 underline">
            {user.firstName}'s Feedback
          </div>
          <div className="mb-4 flex justify-end">
            <DarkPrimaryButton onClick={() => setShowNewFeedbackModal(true)}>
              Add new feedback
            </DarkPrimaryButton>
          </div>
          <div className="overflow-y-scroll" style={{ height: '80vh' }}>
            <Table
              columns={columns}
              dataSource={feedback}
              pagination={{
                defaultPageSize: 10,
              }}
            />
          </div>
        </div>
        <NewFeedbackModal
          user={user}
          show={showNewFeedbackModal}
          onClose={() => setShowNewFeedbackModal(false)}
          onComplete={() => {
            setShowNewFeedbackModal(false)
            refetch()
          }}
        />
      </Modal>
    </Overlay>
  )
}

export default FeedbackModal
